import { SegmentedButton } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { COLLECTIONS_TAB } from '@hero/constants';
import { PageLayout } from '@hero/layouts';
import { CollectionTypeTable } from '@hero/molecules';
import { ROUTE_PATHS } from '@hero/routes';

export default function CollectionsFeaturedPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const collectionOptions = [
    {
      value: COLLECTIONS_TAB.saved,
      label: t('saved'),
      path: ROUTE_PATHS.COLLECTIONS()
    },
    {
      value: COLLECTIONS_TAB.featured,
      label: t('featured'),
      path: ROUTE_PATHS.COLLECTIONS_FEATURED()
    }
  ];

  return (
    <PageLayout
      header={{
        title: t('collections')
      }}
    >
      <SegmentedButton
        activeTab={COLLECTIONS_TAB.featured}
        onChange={tab => {
          const path = collectionOptions.find(option => option.value === tab)?.path;
          navigate(path);
        }}
        withLine
        options={collectionOptions}
        updateHash={false}
      />
      <div style={{ marginBottom: '16px' }} />
      <CollectionTypeTable activeTab={COLLECTIONS_TAB.featured} />
    </PageLayout>
  );
}
